import Logger from 'shared/utils/Logger';
import { createAttachmentReporter } from 'shared/helpers/src/attachment-analytics';
import analyticsService from './analytics.service';

const logger = Logger.create({ loggerName: 'AttachmentAnalytics' });

export const attachmentAnalytics = createAttachmentReporter(
  (eventName, properties) => analyticsService.track(eventName, properties),
  (message, details) => logger.warn(message, details),
);
